import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=67ddc534&scoped=true&lang=pug"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"
import style0 from "./Editar.vue?vue&type=style&index=0&id=67ddc534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddc534",
  null
  
)

export default component.exports